import { useLanguageStore } from '../store/useLanguageStore';
import { translations } from '../i18n/translations';

export function useTranslation() {
  const { language } = useLanguageStore();
  
  // Ensure we always return a valid translation object
  const t = translations[language] || translations.en;
  
  return {
    t,
    language,
  };
}